import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["standard", "iframe"]

  connect() {
    this.toggle()
  }

  toggle() {
    const type = this.element.querySelector("#contentTypeSelect").value
    if (type === "iframe") {
      this.iframeTarget.style.display = ""
    } else {
      this.standardTarget.style.display = ""
      this.iframeTarget.style.display = "none"
    }
  }
}